var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audience-volume-graph-chart"},[_c('v-chart',{staticClass:"w-chart--audience-volume",staticStyle:{"width":"404px","height":"300px"},attrs:{"option":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }